import Cookies from 'js-cookie';

export default function popup() {
  const sels = {
    popup: '.popup',
    close: '.popup__close',
  };

  // No popup, exit
  if (!$(sels.popup).length) {
    return;
  }

  const hidePopup = function () {
    $(sels.popup).removeClass('visible');
    Cookies.set('hide-popup-piazza', $(sels.popup).attr('id'));
  };

  const showPopup = function () {
    $(sels.popup).addClass('visible');
  };

  // Show popup on page load
  showPopup();

  // Hide popup when clicking on button
  $('body').on('click', sels.close, function (e) {
    e.preventDefault();
    hidePopup();
  });
}
